import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

export function useView(viewId: string) {
    const { analytics } = useSelector((state: ApplicationState) => state);
    const view = analytics.views[viewId];

    return { view, viewId };
}
